import { updateDeliveryAddress } from "api/account";
import InsButton from "components/InsButton/InsButton";
import InsInput from "components/InsInput/InsInput";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setAccountDeliveryAddress } from "store/actions/accountActions";
import { setAddress } from "store/actions/storeActions";
import Validate from "../../../ressources/validation";

const EditAddress = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const deliveryAddress = useSelector((state) => state.store.address);
  const account = useSelector((state) => state.account);
  const config = useSelector((state) => state.config);
  const [fieldstoBeRendered, setRenderedFields] = useState([
    { name: "address", required: true, value: deliveryAddress?.address },
    { name: "address2", required: false, value: deliveryAddress?.address2 },
    { name: "postal_code", required: true, value: deliveryAddress?.postalCode },
    { name: "city", required: true, value: deliveryAddress?.city }
  ]);

  useEffect(() => {
    const address_form = config.address_form?.[account.country_code] ?? [];
    const addressFormFieldValues = [...address_form].map((field) => {
      return {
        ...field,
        value: deliveryAddress?.[field.name] || "",
        error: null,
      }
    })
    setRenderedFields([...fieldstoBeRendered, ...addressFormFieldValues]);
  }, []);

  useEffect(() => {
    console.log(deliveryAddress);
  }, [deliveryAddress]);


  const handleSubmit = (e) => {
    e.preventDefault();
    const newDeliveryAddress = {};
    fieldstoBeRendered.forEach((field) => {
      if (field.name === "postal_code") {
        newDeliveryAddress.postalCode = field.value;
      } else if (field?.value?.trim()) {
        newDeliveryAddress[field.name] = field.value;
      }
    }
    );
    updateDeliveryAddress(newDeliveryAddress).then(() => {
      dispatch(setAccountDeliveryAddress(newDeliveryAddress));
      dispatch(setAddress(newDeliveryAddress));
      onClose();
    });
  };

  const validateForm = () => {
    return fieldstoBeRendered.every((el) => validateField(el)(false));
  };

  const handleChange = (input) => (e) => {
    const value = e.target.value;
    const index = fieldstoBeRendered.findIndex((el) => el.name === input);
    let newFields = [...fieldstoBeRendered];
    newFields[index].value = value;
    if (!newFields[index].required && !value?.trim()) {
      newFields[index].error = null;
    }
    setRenderedFields(newFields);
  };

  const validateField = (field) => (displayError = true) => {
    let error = null;
    const index = fieldstoBeRendered.findIndex((el) => el.name === field.name);
    const value = field?.value?.trim();
    if (field.name === "phone") {
      if (value || field.required) {
        error = Validate("addressPhone", value);
      }
      else {
        return true;
      }
    } else if (!fieldstoBeRendered[index].required) {
      return true;
    }
    else {
      error = !value ? "error_required" : null;
    }

    if (displayError) {
      let newFields = [...fieldstoBeRendered];
      newFields[index].error = error;
      setRenderedFields(newFields);
    }
    return !error;
  };

  const renderPhoneNumber = (field) => {
    return (
      <div>
        <InsInput
          name={field.name}
          onChange={(e) => handleChange(field.name)(e)}
          onBlur={() => {
            validateField(field)();
          }}
          placeholder={t(field.name)}
          value={field.value}
          error={field.error}
        />
      </div>
    );
  };

  const renderPostalCode = (field) => {
    return (
      <div>
        <InsInput
          name={field.name}
          type="number"
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 5);
          }}
          maxLength="5"
          placeholder={t(field.name)}
          value={field.value}
          onChange={(e) => handleChange(field.name)(e)}
        />
      </div>
    );
  }

  const renderFields = (field) => {
    return (
      <div>
        <InsInput
          name={field.name}
          type="text"
          placeholder={t(field.name)}
          value={field.value}
          onChange={(e) => handleChange(field.name)(e)}
          maxLength="115"
        />
      </div>
    );
  };

  return (
    <div className="modal_edit_address">
      <div className="close" onClick={onClose}></div>
      <div className="modal_header">
        <div className="title">{t("my_delivery_address")}</div>
      </div>
      <form className="modal_content" onSubmit={handleSubmit}>

        {fieldstoBeRendered.map((field, index) => {
          switch (field.name) {
            case "phone":
              return (
                <div key={field.name + index}>
                  {renderPhoneNumber(field)}
                </div>
              );

            case "postal_code":
              return (
                <div key={field.name + index}>
                  {renderPostalCode(field)}
                </div>
              );

            default:
              return (
                <div key={field.name + index}>
                  {renderFields(field)}
                </div>
              );
          }
        })}

        <InsButton
          text={t("save")}
          // onClick={saveAddress}
          disabled={!validateForm()}
        />
        <p className="cancel" onClick={onClose}>
          {t("cancel")}
        </p>
      </form>
    </div>
  );
};

export default EditAddress;
